// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2Cw7m","savePackageButton":"ClientWallet_savePackageButton__1zCC9"};